module.exports = __webpack_public_path__ + "static/img/meuKuang_details.c7ef90f3.jpg";